import React from "react";
import { transparentize } from "polished";
import CircularProgress from "@material-ui/core/CircularProgress";
import Portal from "@material-ui/core/Portal";
import { Subheading } from "./typography/Subheading";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

type Props = {
  title?: string;
  fullScreen?: boolean;
};

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    ...theme.mixins.fullAbsolute,
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    zIndex: 2,

    backgroundColor: transparentize(0.15, theme.palette.secondary.main),
    color: theme.palette.common.white
  }
}));

export function ProgressOverlay({ fullScreen, title }: Props) {
  const classes = useStyles({});
  const overlay = (
    <div className={classes.root}>
      <div>
        <CircularProgress color="inherit" />
      </div>

      {title && (
        <div>
          <Subheading color="inherit" style={{ color: "white" }}>
            {title}
          </Subheading>
        </div>
      )}
    </div>
  );

  return fullScreen ? <Portal>{overlay}</Portal> : overlay;
}
